/* eslint-disable camelcase */
import React from 'react';
import TreeView from '../../GroupTreeView/GroupTreeView';
import { LookupDocumentType, ITabParams } from '../../../config/types';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../redux/store';
import { openLookupsTab } from './LookupsUtils';
import { triggerEvent } from '../../../redux/event';
import {
  fetchLookupGroups,
  fetchLookups,
  updateLookupGroups
} from '../../../redux/lookup';
import { LookupCollection } from '@digitalworkflow/dwtranslateclient';
import { setSelectedNode } from '../../../redux/activeNode';
import {
  builderPageTypes as BPT,
  builderPageTypes
} from '../../../config/constants/builderPageTypes';
import { updateDataEverywhere } from '../../../utils';
import { ITreeViewData } from '@digitalworkflow/dwtranslateclient/lib/Models/Module/ModuleCollection';
import styles from '../Renderers.module.scss';

export const GroupsLookup = ({
  ref,
  type,
  selectedRows,
  gridReferences,
  setCurrentEventAPI,
  setSelectedRowIndex,
  setSelectedRows,
  fetchData,
  setRowSelectedFlag,
  setTabsRef,
  updateData
}: ITabParams) => {
  const groups: ITreeViewData[] = useSelector(
    (state: RootState) => state.lookup.groups
  );
  const lookupsData: any = useSelector(
    (state: RootState) => state.lookup.lookups
  );

  const dispatch = useAppDispatch();

  function reduxUpdater() {
    dispatch(fetchLookups());
    dispatch(fetchLookupGroups());
  }

  function openForm() {
    dispatch(triggerEvent('showModalEvent'));
  }

  function openDuplicateForm() {
    dispatch(triggerEvent('showDuplicateModalEvent'));
  }

  /**
   * callback to handle when a group is clicked in tree view
   * @param title string name of the group clicked
   */
  function handleGroupClick(title: string) {
    if (!lookupsData[title]) return;

    const rows: Partial<LookupDocumentType>[] = [];

    Object.keys(lookupsData[title]).forEach((k) => {
      rows.push(lookupsData[title][k].data);
    });

    const tabId = title + '_tab';

    const tabAlreadyPresent = ref?.find(tabId);

    tabAlreadyPresent
      ? ref?.updateTab(tabId, null)
      : openLookupsTab({
          ref,
          title,
          rows,
          firstTab: false,
          type,
          selectedRows,
          gridReferences,
          fetchData,
          setSelectedRows,
          setSelectedRowIndex,
          setCurrentEventAPI,
          setRowSelectedFlag,
          setTabsRef,
          updateData,
          updateMetaData: (data) => {
            updateDataEverywhere(
              ref,
              data.id,
              data,
              builderPageTypes.lookups,
              reduxUpdater
            );
          }
        });

    dispatch(setSelectedNode(title));
  }

  async function handleDrop(newData: ITreeViewData[]) {
    for (let index = 0; index < newData.length; index++) {
      if (newData[index].parent !== groups[index].parent) {
        const parentIndex = newData.findIndex(
          (v) => v.id === newData[index].parent
        );
        await LookupCollection.updateKeyGroup(
          newData[index].text as string,
          newData[parentIndex].text as string
        );
        dispatch(updateLookupGroups(newData));
        break;
      }
    }
  }

  return (
    <div id={styles.treeView} className='overflow-y-auto h-100'>
      <TreeView
        pageType={BPT.lookups}
        data={groups}
        setShowModal={() => openForm()}
        setShowDuplicateModal={() => openDuplicateForm()}
        handleGroupClick={(title) => handleGroupClick(title)}
        handleDrop={(newTreeData: ITreeViewData[]) => handleDrop(newTreeData)}
        tabRef={ref}
      />
    </div>
  );
};

export const HistoryLookup = () => {
  return (
    <div>
      <span>History available in V2</span>
    </div>
  );
};
